import React, {useEffect, useContext, useState} from 'react'
import { Routes, Route } from "react-router-dom";
import Home from './Pages/Frontend/Home';
import Srp from './Pages/Frontend/Srp';
import OurTeams from './Pages/Frontend/OurTeams';
import TradeSellLuxuryCar from './Pages/Frontend/TradeSellLuxuryCar';

const AppRoutes = () => {

  return (
    <>
        <Routes>
            <Route exact path="/" Component={Home} />
            <Route exact path="/srp" Component={Srp} />
            <Route exact path="/our-team" Component={OurTeams} />
            <Route exact path="/trade-sell-luxury-car" Component={TradeSellLuxuryCar} />
        </Routes>
    </>
  )
}

export default AppRoutes